import React from 'react';

import s from './DropdownMenu.module.scss';

interface Props {
  className: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  show: boolean;
  blurTimeOut?: number;
  onSetActiveMenu: (value: boolean) => void; // eslint-disable-line no-unused-vars
}

function DropdownMenu({
  className,
  icon,
  children,
  show,
  blurTimeOut,
  onSetActiveMenu,
}: Props): React.ReactElement {
  return (
    <div
      className={`${className || ''} ${s.dropdownWrapper}`}
      onBlur={(event: any) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
          if (blurTimeOut != null) {
            setTimeout(() => {
              onSetActiveMenu(false);
            }, blurTimeOut);
          } else {
            onSetActiveMenu(false);
          }
        }
      }}
    >
      <button
        className={s.toggleButton}
        type="button"
        onClick={() => {
          onSetActiveMenu(!show);
        }}
        aria-label="toggle Menü"
      >
        {icon}
      </button>
      <div className={`${s.dropdownMenu} ${show ? s.show : ''}`}>
        <nav className={s.dropdownMenuInner}>{children}</nav>
      </div>
    </div>
  );
}

DropdownMenu.defaultProps = {
  blurTimeOut: undefined,
};

export default DropdownMenu;
